import spinner from '@/components/spinner/spinner'
import Header from '@/components/header/header'
import ModalCities from '@/components/modalCities/modalCities'
import BasePage from '@/views/BasePage/BasePage'
import ModalAddress from '@/components/modalAddressHome/modalAddress'
import ModalProgram from '@/components/modalAsideProgram/modalAsideProgram'
import ModalCoupon from '@/components/modalCoupon/modalCoupon'
import ModalPromoExceeded from '@/components/modalPromoExceeded/modalPromoExceeded'
import BurguerMenu from '@/components/burguerMenu/burguerMenu';

import { Component, Watch } from 'vue-property-decorator'
import { Action, Mutation, Getter } from 'vuex-class'

import ModalWompi from '@/components/modalWompi/modalWompi'

@Component({
  components: {
    spinner,
    Header,
    ModalCities,
    ModalAddress,
    ModalProgram,
    ModalWompi,
    ModalCoupon,
    ModalPromoExceeded,
    BurguerMenu
  }
})
export default class App extends BasePage {
  @Action action_autoLogin: any
  @Action action_getCountry: any
  @Action action_getCitiesInformation: any

  @Mutation IS_TOKEN: any

  @Getter getUser: any
  @Getter getIsToken: any
  @Getter getIsSelectCountry: any
  @Getter getOpenBurguerMenu;
  @Mutation IS_SELECT_COUNTRY
  @Mutation OPEN_BURGUER_MENU;

  // Coupon Modal
  @Getter getOpenCouponModal: any
  @Mutation OPEN_COUPON_MODAL: any

  // Promo Exceeded Modal
  @Getter getOpenPromoExceededModal: any
  @Mutation OPEN_PROMO_EXCEEDED_MODAL: any

  showAddressModal = false
  showProgramModal = false
  showWompiModal = false
  showCouponModal = false
  showPromoExceededModal = false;
  cardId = 0

  citiesWithInformation = []

  mounted() {
    
    this.$root.$on('address-modal', () => {
      this._toggleAddressModal();
    });

    this.$root.$on('wompi-modal', (cardId) => {
      this.cardId = cardId
      this._toggleWompiModal();
    });


    this.$root.$on('program-modal', () => {
      this._toggleProgramModal();
    });

    this.$root.$on('coupon-modal', () => {
      this._toggleCouponModal();
    });

    this.$root.$on('promo-exceeded-modal', () => {
      this._togglePromoExceededModal();
    })

    if (this.getIsToken) {
      this.action_autoLogin();
    } else {
      this.action_getCountry()
    }

    (this as any).$ga.set({ userId: this.getUser.id })


    const self = this
    this.$on('online', function () {
      self.$swal({
        imageUrl: '/assets/images/ui/cohete.png',
        imageWidth: 100,
        title: 'Yuju...',
        text: 'Ya tienes internet :)',
        timer: 2500,
        showConfirmButton: false
      })
    })
    this.$on('offline', function () {
      self.$swal({
        title: 'Oops...',
        text: 'No tienes Conexión a internet :(',
        timer: 2500,
        showConfirmButton: false
      })
    })

    this._togglePromoExceededModal();
  }

  _toggleAddressModal() {
    this.showAddressModal = !this.showAddressModal;
  }

  _toggleWompiModal() {
    this.showWompiModal = !this.showWompiModal;
  }

  _toggleProgramModal() {
    this.showProgramModal = !this.showProgramModal
  }

  _toggleCouponModal() {
    this.OPEN_COUPON_MODAL(!this.getOpenCouponModal);
  }

  _togglePromoExceededModal() {
    this.showPromoExceededModal = !this.showPromoExceededModal;
  }

  _setDayProgram(day) {
    // this.dayProgram = day
  }

  get getBarMenu() {
    const name = this.$route.name
    return this.getIsUnderMobile &&
      name !== 'checkout' &&
      name !== 'city'
  }

  get getFullscreen() {
    const fullscreenViews = ['login', 'loginCellphone', 'loginCellCode', 'createCellCode', 'loginRegister', 'loginReset', 'loginAccount']
    return fullscreenViews.includes(this.$route.name)
  }

  get getHeader() {
    const name = this.$route.name
    return name !== 'checkout'
  }

  get isGeneralOverlay() {
    let response = false;
    if(this.getOpenBurguerMenu) {
      response = true;
    }
    return response;
  }

  _toggleModalCities() {
    this.IS_SELECT_COUNTRY(true)
  }

  _toggleOverlay() {
    if(this.getOpenBurguerMenu) {
      this.OPEN_BURGUER_MENU(false);
    }
  }

};
